import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';
import { fmtInt, fmtUsd } from '@/lib/format';

interface StockRow {
  wine_id: number;
  name: string;
  winery: string | null;
  vintage: number | null;
  stock: number;
  avg_cost_usd: number | null;
}

export function InventoryPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['inventory', 'stock'],
    queryFn: async () => (await api.get<{ data: StockRow[] }>('/inventory/stock')).data.data,
  });

  return (
    <div className="p-8">
      <header className="mb-6">
        <h1 className="text-2xl font-medium">Inventario</h1>
        <p className="text-sm text-notion-500">Stock actual por vino.</p>
      </header>

      <div className="card overflow-x-auto">
        {isLoading ? (
          <div className="p-12 text-center text-notion-500">Cargando…</div>
        ) : !data?.length ? (
          <div className="p-12 text-center text-notion-500">No hay stock cargado.</div>
        ) : (
          <table className="table-base min-w-[640px]">
            <thead className="bg-white">
              <tr>
                <th>Vino</th>
                <th>Bodega</th>
                <th>Añada</th>
                <th>Stock</th>
                <th>Costo prom. USD</th>
                <th>Valor USD</th>
              </tr>
            </thead>
            <tbody>
              {data.map((r) => (
                <tr key={r.wine_id} className="hover:bg-white">
                  <td className="font-medium">{r.name}</td>
                  <td>{r.winery ?? '—'}</td>
                  <td>{r.vintage ?? '—'}</td>
                  <td>{fmtInt(r.stock)}</td>
                  <td>{fmtUsd(r.avg_cost_usd)}</td>
                  <td className="font-medium">
                    {r.avg_cost_usd != null ? fmtUsd(r.stock * r.avg_cost_usd) : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
